<div fxLayout="row" fxLayoutGap="8px">
  <div [ngStyle]="{ padding: '4px' }">
    <img
      src="//storage.googleapis.com/ttc-static-images/emoji-waving-hand_1f44b.png"
      alt="emoji waving hand"
      [ngStyle]="{ height: '18px', width: '18px' }"
    />
  </div>
  <p>
    {{ text }}
  </p>
</div>
